import React from "react";
import DefaultLayout from "@configuratorware/configurator-frontendgui/App/Modules/Creator/Layouts/DefaultLayout";
import { withStyles } from "@material-ui/core/styles";
import withWidth from "@material-ui/core/withWidth";
import LoadingOverlay from "../../../../Framework/Components/LoadingOverlay";

const styles = (theme) => ({
  root: {
    background: theme.palette.backgroundColor,
  },
  container: {
    top: 0,
    height: "100%",
    maxHeight: `calc(100% - ${+theme.layout.footerbar.heightSm * 3}px)`,
    [theme.breakpoints.up("sm")]: {
      height: "100%",
      maxHeight: `calc(100% - ${+theme.layout.footerbar.height}px)`,
    },
    [theme.breakpoints.up("xl")]: {
      maxHeight: `calc(100% - ${+theme.layout.footerbar.height}px)`,
    },
  },
  outerContainer: {
    maxHeight: "calc(100vh - 60px)",
    maxWidth: "100vw",
    margin: 0,
  },
  visualization: {
    position: "absolute",
    width: "100%",
    height: "100%",
    [theme.breakpoints.down("xs")]: {
      height: "75%",
    },
    "&.withBottomList": {
      height: "100%",
    },
  },
  productsList: {
    "&.horizontal": {
      top: 0,
      height: theme.layout.productsList.height,
    },
  },
});

const CustomDefaultLayout = (props) => (
  <DefaultLayout
    {...props}
    displayVerticalList={false}
    LoadingComponent={LoadingOverlay}
  />
);

export default withStyles(styles, { name: "DefaultLayout" })(
  withWidth({ initialWidth: "xl" })(CustomDefaultLayout)
);
